<template>
  <el-dialog
      v-el-drag-dialog
      :title="disabled ? '详情' : model.pkid ? '编辑' : '新增'"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="500px"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :disabled="disabled"
        :model="model"
        :rules="ruleValidate"
        class="form"
        label-width="100px">
      <el-form-item label="税收分类编码" prop="code">
        <el-input v-model="model.code" placeholder="请输入税收分类编码"/>
      </el-form-item>
      <el-form-item label="税收分类名称" prop="typeName">
        <el-input v-model="model.typeName" placeholder="请输入税收分类名称"/>
      </el-form-item>
      <el-form-item label="备注" prop="note">
        <el-input v-model="model.note" type="textarea" :rows="3" placeholder="请输入备注"/>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button v-if="!disabled" :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    name: "InvoiceTypeCodeEdit",
    data() {
      return {
        disabled: false,
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        model: {
          pkid: 0,
          code: "",
          typeName: "",
          note: "",
        },
        ruleValidate: {
          code: [
            { required: true, trigger: "blur", message: "请输入税收分类编码" },
          ],
          typeName: [
            { required: true, trigger: "blur", message: "请输入税收分类名称" },
          ],
        },
      };
    },

    methods: {
      open(row, mark) {
        this.dialogVisible = true;
        this.disabled = !!mark;
        this.$nextTick(() => {
          this.$refs.form && this.$refs.form.clearValidate();
        });
        if (row) {
          this.getData(row.pkid);
        } else {
          this.model = { pkid: 0, code: "", typeName: "", note: "" };
        }
      },

      getData(id) {
        this.contentLoading = true;
        this.$http
          .get("basic", `invoiceApplicationTypes/${id}`)
          .then((resp) => {
            if (resp.success) {
              this.model = resp.data;
            }
            this.contentLoading = false;
          })
          .catch(() => {
            this.contentLoading = false;
          });
      },

      handleSubmit() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .save("basic", "invoiceApplicationTypes", this.model)
              .then((resp) => {
                if (resp.success) {
                  this.$emit("save-success");
                  this.$message.success(this.model.pkid ? "编辑成功" : "新增成功");
                  this.dialogVisible = false;
                }
                this.submitLoading = false;
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>
